import React from 'react';
export function Eucalyptus({
  className,
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) {
  return <svg viewBox="0 0 100 100" className={className} style={style} fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-26">
      <path d="M50 95C50 95 45 50 50 5C55 50 50 95 50 95Z" stroke="currentColor" strokeWidth="2" fill="none" data-id="element-27" />
      <circle cx="50" cy="15" r="8" opacity="0.9" data-id="element-28" />
      <circle cx="35" cy="30" r="10" opacity="0.8" data-id="element-29" />
      <circle cx="65" cy="35" r="9" opacity="0.85" data-id="element-30" />
      <circle cx="40" cy="55" r="11" opacity="0.75" data-id="element-31" />
      <circle cx="60" cy="60" r="10" opacity="0.8" data-id="element-32" />
      <circle cx="45" cy="80" r="8" opacity="0.7" data-id="element-33" />
      <circle cx="55" cy="85" r="7" opacity="0.6" data-id="element-34" />
    </svg>;
}